import React from 'react';

const UserReferralFormModal = React.lazy(() => import('../components/FormModal'));
const userReferralModalRegistry = {
    core_userReferralId: UserReferralFormModal
};
export default userReferralModalRegistry;
